import type { PointerEvent as ReactPointerEvent } from 'react'

import { ColumnResizeHandle, TableHead } from '@/components/ui'
import { cn } from '@/utils'
import { SortIcon } from './SortIcon'
import type { Sort } from './types'

interface SortableHeadProps {
  label: string
  sort: Sort
  sortKey: string
  onClick: (key: string) => void
  className?: string
  onResizeStart?: (event: ReactPointerEvent<HTMLElement>) => void
  isResizing?: boolean
}

export const SortableHead = ({
  label,
  sort,
  sortKey,
  onClick,
  className = '',
  onResizeStart,
  isResizing,
}: SortableHeadProps) => (
  <TableHead
    className={cn(
      'text-blue-7 font-medium cursor-pointer active:bg-neutral-100 select-none',
      className,
    )}
    onClick={() => onClick(sortKey)}
  >
    <div
      className={cn(
        'flex items-center',
        className.includes('text-right') && 'justify-end',
      )}
    >
      <span className="min-w-0 truncate">{label}</span>
      <SortIcon sort={sort} sortKey={sortKey} />
    </div>

    {onResizeStart && (
      <ColumnResizeHandle
        onResizeStart={onResizeStart}
        isResizing={isResizing}
      />
    )}
  </TableHead>
)
